export const hudMessages: Record<string, string> = {
	hint_howToWait: "Press [X] to wait a turn",
	hint_destroyPortals: "Destroy portals to stop enemy spawns",
	hint_autoShoot: "Press [TAB] to auto-shoot a nearby enemy",
	hud_powerPlantActivated: "Power plant now online",
	hud_powerPlantGate_noPower: "Cannot open doors. No power.",
	hud_powerPlantGate_noKeyCard: "Keycard required.",
	hud_powerPlantGate_opening: "Opening gates...",
	hud_vendingMachine_noPower: "No power",
	hud_terminal_noPower: "No power",
	hud_terminal_noKeyCard: "Keycard required.",
	hud_reachedArea: "$1",
	hud_characterUnlocked: "New character unlocked: $1",
	hud_firstWeaponPickup: "You got $1 — select with [$2]",
	hud_lowHpMedikit: "Low health — press [H] to use a medikit",
	prompt_activatePowerPlant: "ENTER - Activate power plant",
	prompt_openPowerPlantGate: "ENTER - Open Gate doors",
	prompt_readSign: "ENTER - Read sign",
	prompt_useVendingMachine: "ENTER - Use vending machine",
	prompt_useTerminal: "ENTER - Use terminal",
};
